import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

var requestSchema = yup.object({
  clinicFromId: yup.number().required(),
  clinicToId: yup.number().required(),
});

export var useTransferClinicProductsMutation = (options = {}) => {
  return useMutation(async (dto) => {
    var req = requestSchema.validateSync(dto, {
      strict: true,
    });
    return http.post(HTTP_ENDPOINTS.transferClinicProducts(), {
      from_clinic_id: req.clinicFromId,
      to_clinic_id: req.clinicToId,
    });
  }, options);
};
